process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
import * as React from 'react';
import { NavigationComponent } from './ui/components/navigation/navigationcomponent';
import { BlacklistDtoImpl } from './core/dto/blacklist/blacklistdto';
import { ListTonesDto, ListTonesDtoImpl } from './core/dto/listtones/listtonesdto';
// import { MyAccountComponent } from '../../crbtportal/ui/components/myaccount/myaccountcomponent';

export class MainComponent extends React.Component<any, any>
{
    render()
    {
        return (
                <>
                <div/>
                {/* <BlackListRowComponent  position={0} blacklistDto={this.getData()} onDeleteClick={()=>""} context={this.props.baseContext}/> */}
                {/* <AlertComponent alertType={"Error"} onClick={()=>''} onCloseButtonClick={()=>''} alertMessage={"Your order completed successfully"} context={this.props.baseContext}/> */}
                <NavigationComponent context={this.props.baseContext}/>
                {/* <LandingPageComponent context={this.props.baseContext}/> */}
                {/* <TestRadialProgressBar/> */}
                {/* <TuneSettingsComponent onTuneSettingsAdd={()=>{}} closePopup={()=>{}} toneDto={this.getData()} toneOptionsType={ToneOptionsType.TONE} context={this.props.baseContext} /> */}
                {/* <button onClick={(e)=>this.getPastDate(30)} type="button">Click Me!</button> */}
                   {/* <TestDropDownList context={this.props.baseContext} /> */}
                    {/* <TestFloatingTextComponent context={this.props.baseContext} /> */}
                    {/* <MyAccountComponent context={this.props.baseContext}/> */}
                    {/* <TestFacebookShare context={this.props.baseContext} /> */}
                    {/* <TestPopUp context={this.props.baseContext}/> */}
                    {/* <TellAFriendComponent closePopup={()=>""} toneDto={this.getData()} context={this.props.baseContext}/> */}
                    {/* <HeaderComponent context={this.props.baseContext}/> */}
                    {/* <ToolbarComponent context={this.props.baseContext}/>
                    <div style={{width: '100%', height: '800px'}}>
                    {
                        "".
                    }
                    </div>
                    <FooterComponent context={this.props.baseContext}/> */}
                    {/* <TuneComponent context={this.props.baseContext} /> */}
                </>);
    }

    getDate():string
    {
        let currentDate = new Date();
        let dd = currentDate.getDate().toString();
        let mm = (currentDate.getMonth()+1).toString();
        let yyyy = currentDate.getFullYear().toString();
       
        if(currentDate.getDate()<10) 
        {
            dd ='0'+dd;
        } 

        if(currentDate.getMonth()<10) 
        {
          mm='0'+mm;
        } 
        let today =dd+'-'+mm+'-'+yyyy;
        console.log("the current date: ---",today);
        return today;        
    }
     
    getPastDate(days:number):string
    {
        let date = new Date();
        let last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
        let day = last.getDate().toString();
        let month = (last.getMonth()+1).toString();
        let year = last.getFullYear();
        if(last.getDate()<10)
        {
            day = '0'+day;
        }
        if(last.getMonth()<10)
        {
            month = '0'+month;
        }
       
        let pastDate = day+"-"+month+"-"+year;

        console.log("past date :",pastDate);
        return pastDate;
    }
    getData()
    {
        let blacklist = new BlacklistDtoImpl();
        blacklist.setBlacklistName("jhgfdfgh");
        blacklist.setMsisdnB("876543456789");
        return blacklist;
    }



    getMyTonesCardDetails():ListTonesDto
    {
        let tone1 = new ListTonesDtoImpl();
        tone1.setStatus("");
        return tone1;
    }
    // private testSettings()
    // {
    //     let settingsData = JSON.parse('{"settings":{ "others":{             "Categories_ENGLISH":{   "enable":true,                "description":"some value",              "attribute":"categroyId|Myanmar|http://mytune.telenor.com.mm/image/Flag_Myanmar.jpg, categroyId|English|http://api-mytune.telenor.com.mm/image/british_flag.jpg, categroyId|Thai|http://api-mytune.telenor.com.mm/image/thai_flag.jpg"           },           "TOTALSONGS":{           "enable":true,              "description":"Tax value",              "attribute":"????????????????????? $count$ Items"           }         }      }}');

    //     let context: BaseContext = this.props.baseContext;

    //     context.setConfigurationSettings(settingsData.settings.others);

    //     console.log("withoutlanguage: " + context.getConfigurationSettings().getProperty("TOTALSONGS"));
    //     console.log("withlanguage: " + context.getConfigurationSettings().getPropertyBasedOnLanguage("Categories"));
    // }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/maincomponent.tsx